// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eu9n","top":"styles_top__2SEpC","left":"styles_left__CAtpn","description":"styles_description___loyM"};